import {Routes} from '@angular/router';
import {FxRateReportContentComponent} from './components/fx-rate-report-content/fx-rate-report-content.component';
import {AddFxRateReportComponent} from './components/add-fx-rate-report/add-fx-rate-report.component';
import {FxRateViewReportComponent} from './components/fx-rate-view-report/fx-rate-view-report.component';
import { PlatformToolContainerComponent } from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';
import { AuthGuard } from '@core/services/auth-guard.service';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
/**
 * Created by zinia on 4/13/2020.
 */
export const FxRateRoutes: Routes = [
  {
    path: 'itrce/fxrates',
    //component: FxRateReportContentComponent,
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'itrce/fxrates/add-report/:reportID',
    // component: AddFxRateReportComponent,
    component: PlatformLinkCreatorComponent,
  }, {
    path: 'itrce/fxrates/fx-rates-view-report/:reportName/:reportID',
    //component: FxRateViewReportComponent,
    component: PlatformLinkCreatorComponent,
  },
  {
    path: 'orbitax-connect/itrce/fxrates/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
];
